import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth, isFinanceRole } from "@/lib/auth/AuthContext";

// Route-Guard fuer /finanzen (5.30). Strategische Finanz-KPIs + Szenario +
// Rechnungen-Liste — admin/buchhaltung/superadmin. PL bleibt aussen vor
// (eigenes Performance-Tile auf Home). Spiegelt isFinanceRole im Service-
// Layer (Defense in Depth, CLAUDE.md Prinzip 2).
export function RequireFinance({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();
  if (status === "loading") return null;
  if (!user || !isFinanceRole(user.role)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
